import React, { useEffect, useState } from "react";
import { Calendar } from "@/components/ui/calendar";
import { api } from "@/lib/api";

const ymd = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const parse = (s: string) => { const [y, m, d] = s.split("-").map(Number); return new Date(y, m - 1, d); };

export function SlotPicker({ date, time, onChange, refreshKey }: { date: string; time: string; onChange: (d: string, t: string) => void; refreshKey?: number }) {
  const [open, setOpen] = useState<Set<string> | null>(null);
  const [slots, setSlots] = useState<any[] | null>(null);
  useEffect(() => { api.get("/consultations/availability").then((r) => setOpen(new Set(r.data.open_dates))).catch(() => setOpen(new Set())); }, [refreshKey]);
  useEffect(() => {
    if (!date) { setSlots(null); return; }
    setSlots(null);
    api.get("/consultations/availability", { params: { date } }).then((r) => setSlots(r.data.slots)).catch(() => setSlots([]));
  }, [date, refreshKey]);
  const first = open && open.size ? parse([...open][0]) : new Date();
  return (
    <div className="grid md:grid-cols-[auto_1fr] gap-6 md:gap-10 items-start" data-testid="slot-picker">
      <div className="border border-neutral-300 bg-white w-fit" data-testid="consult-calendar">
        {open === null ? <p className="p-6 text-sm text-neutral-600">Loading availability…</p> : (
          <Calendar mode="single" showOutsideDays={false} selected={date ? parse(date) : undefined} defaultMonth={date ? parse(date) : first}
            onSelect={(d: Date | undefined) => d && onChange(ymd(d), "")} disabled={(d: Date) => !open.has(ymd(d))} fromDate={new Date()} />
        )}
      </div>
      <div>
        <span className="eyebrow text-neutral-500 block mb-3">{date ? `Available times · ${parse(date).toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "long" })}` : "Choose a date to see times"}</span>
        {date && slots === null && <p className="text-sm text-neutral-600">Loading…</p>}
        {slots && slots.length === 0 && <p className="text-sm text-neutral-600" data-testid="consult-no-slots">No times left on this day — please pick another date.</p>}
        <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
          {(slots || []).map((s) => (
            <button type="button" key={s.time} disabled={!s.available} onClick={() => onChange(date, s.time)} data-testid={`consult-time-${s.time}`}
              className={`py-2.5 text-sm border transition-colors ${time === s.time ? "bg-neutral-900 text-white border-neutral-900" : s.available ? "border-neutral-300 bg-white hover:border-neutral-900" : "border-neutral-200 text-neutral-300 line-through cursor-not-allowed"}`}>{s.time}</button>
          ))}
        </div>
        {open && open.size === 0 && <p className="text-sm text-neutral-600" data-testid="consult-fully-booked">We're fully booked at the moment — please email help@somnio.co and we'll find a time.</p>}
      </div>
    </div>
  );
}
